"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));

var xorWith_1 = tslib_1.__importDefault(require("lodash/xorWith"));

var joinName_1 = tslib_1.__importDefault(require("./joinName"));

function changedKeys(root, valueA, valueB) {
  if (!valueA || valueA !== Object(valueA) || valueA instanceof Date) return isEqual_1.default(valueA, valueB) ? [] : [root];
  if (!valueB) return tslib_1.__spreadArrays([root], Object.keys(valueA).map(function (key) {
    return joinName_1.default(root, key);
  }));
  var changed = xorWith_1.default(Object.entries(valueA), Object.entries(valueB), isEqual_1.default).map(function (pair) {
    return joinName_1.default(root, pair[0]);
  });
  if (changed.length) changed.unshift(root);
  return changed;
}

exports.default = changedKeys;